// MSAL Configuration for Azure AD SSO
import { LogLevel } from "@azure/msal-browser";

// MSAL configuration
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_SSO_CLIENT_ID,
        authority: process.env.REACT_APP_SSO_AUTHORITY,
        redirectUri: process.env.REACT_APP_SSO_REDIRECT_URI,
        postLogoutRedirectUri: process.env.REACT_APP_SSO_REDIRECT_URI,
        navigateToLoginRequestUrl: false
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

// Add scopes here for ID token to be used at Microsoft Graph API endpoints.
export const loginRequest = {
    scopes: ["User.Read", "openid", "profile", "email"]
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

// API Configuration - AUTHENTICATION REQUIRED FOR ALL ENDPOINTS
//
// Every path MUST stay under /api. In prod the SPA is served through the WHO
// Shared AFD at step.who.int, which only routes /api/* to the backend origin —
// anything else falls through to this SPA. (The backend also serves unprefixed
// /upload, /candidate, ... aliases; do not use them, they are unroutable via AFD.)
export const apiConfig = {
    baseUrl: process.env.REACT_APP_API_URL,
    endpoints: {
        health: "/api/health",
        upload: "/api/upload",
        candidate: "/api/candidate",
        download: "/api/download",
        downloadAll: "/api/download_all",
        stats: "/api/stats",
        authConfig: "/api/auth/config",
        authUser: "/api/auth/user"
    }
};

// Check if SSO is enabled - MANDATORY FOR ALL ENVIRONMENTS
export const isSSOEnabled = () => {
    return true; // SSO is ALWAYS enabled, no fallbacks
};

// Development mode configuration
export const isDevelopment = process.env.NODE_ENV === 'development';

// SSO is MANDATORY - no local development bypass
export const localConfig = {
    enabled: false, // ALWAYS require SSO authentication
    mockUser: null  // NO mock user allowed
};
